import {
  BusinessUnitItemSchema,
  VendorItemSchema,
  AccountItemSchema,
} from "@/schemas/index";
import { z } from "zod";

export const ScanDataSetupParamsSchema = z.object({
  AccountId: AccountItemSchema.shape.Id.optional(),
  SubscriptionId: z.string().optional(),
  AccountStatus: z.string().optional(),
  AccountStatusId: z.number().optional(),
  VendorId: VendorItemSchema.shape.Id.optional(),
  AccountNumber: z.string().optional(),
  AccountLogin: z.string().optional(),
  AccountPassword: z.string().optional(),
  SingleAccount: z.boolean().optional(),
  BusinessUnits: z
    .object({
      BusinessUnitId: BusinessUnitItemSchema.shape.Id.optional(),
      AccountNumber: z.string().optional(),
      LocationNumber: z.string().optional(),
      Login: z.string().optional(),
      Password: z.string().optional(),
      Status: z.string().optional(),
      StatusId: z.number().optional(),
    })
    .array(),
});

export type ScanDataSetupParamsType = z.infer<typeof ScanDataSetupParamsSchema>;
